module.exports = __webpack_public_path__ + "img/do.b240de12.svg";